import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import Config from '../../../Config';
import { cgTypeEnum } from '../../../utilities/enums/cgTypeEnum';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import {
  setErrorPage,
  goToPage,
  setServiceMessageType,
  setErrorText,
  setDisplayAlternativePackage,
  setIecResponse
} from './energySaleBlockSlice';
import { callOpenWorkOrderForEnergySaleJet } from '../../../utilities/openWorkOrder';
import { gtag4 } from '../../../utilities/analytics/tracking';

export const createOtp = createAsyncThunk('energySaleBlock/createOtp', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const state = thunkAPI.getState().energySaleBlock;
    const otpDetails = state.otpDetails;

    const firstName = '';
    const lastName = '';

    const request = {
      requestType: "create_otp",
      firstName : firstName,
      lastName : lastName,
      idNumber: otpDetails.identityNumber,
      phoneNumber: otpDetails.phoneNumber,
    }

    const result = await ProviderManager.getProviderData('IECBotCheckSmartMeter', request);

    thunkAPI.dispatch(hideAppLoader());

    if(result.Body.state.toLowerCase() == 'initialized'){
      thunkAPI.dispatch(goToPage('otpVerifyCodePage'));
    }

    return result.Body;
  } catch (err) {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const validateOtp = createAsyncThunk('energySaleBlock/validateOtp', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(goToPage('loadingPage'));

    const state = thunkAPI.getState().energySaleBlock;
    const otpCode = state.otpDetails.verifyCode;
    const sessionId = state.sessionId;

    const request = {
      requestType: "validate_otp",
      sessionId : sessionId,
      otpCode : otpCode
    }

    const result = await ProviderManager.getProviderData('IECBotCheckSmartMeter', request);

    if(result.Body.state.toLowerCase() == 'processing' || result.Body.state.toLowerCase() == 'started'){
      thunkAPI.dispatch(getDetails());
    }
    else{
      thunkAPI.dispatch(setIecResponse(result.Body));
      setPageResponse(result.Body, thunkAPI);
      thunkAPI.dispatch(hideAppLoader());
    }

    return result.Body;
  } catch (err) {
    thunkAPI.dispatch(setErrorPage({errorType: 'GENERAL_ERROR' , isOpenWorkOrder: true, description: 'שגיאה בבדיקת OTP' }));
    // thunkAPI.dispatch(createLead());
  } finally {
  }
});

export const getDetails = createAsyncThunk('energySaleBlock/getDetails', async (data, thunkAPI) => {
  try {

    const state = thunkAPI.getState().energySaleBlock;
    const sessionId = state.sessionId;

    const request = {
      requestType: "get_details",
      sessionId : sessionId,
    }

    const result = await ProviderManager.getProviderData('IECBotCheckSmartMeter', request);

    thunkAPI.dispatch(setIecResponse(result.Body));
    setPageResponse(result.Body, thunkAPI);

    return result.Body;
  } catch (err) {
    thunkAPI.dispatch(setErrorPage({errorType: 'GENERAL_ERROR' , isOpenWorkOrder: true, description: 'שגיאה בקבלת פרטים מחברת החשמל' }));
    thunkAPI.dispatch(createLead());
  } finally {
  }
});

export const getOderPrice = createAsyncThunk('energySaleBlock/getSalePricesAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().energySaleBlock;

    const request =     {
      offerId: state.selectedPackage?.offerId,
      offerName: state.selectedPackage?.title,
      saleType: state.saleType,
      personalInfo: {
        idNumber: state.otpDetails.identityNumber,
        lastName: state.personalInfo.lastName,
        firstName: state.personalInfo.firstName,
        otpPhone: state.otpDetails.phoneNumber,
      },
      energyInfo: {
        counterIds: [
          state.iecResponse.currentConsumption
        ],
        isSmart: state.iecResponse.serviceMigratable,
        contractId: state.iecResponse.contractId,
        currentConsumption: state.iecResponse.currentConsumption
      }
    }

    const result = await ProviderManager.getProviderData('energySaleGetOrderPrice', request);
    thunkAPI.dispatch(hideAppLoader());


    if(result.Body.successCatalogResult.isSuccess){
      thunkAPI.dispatch(goToPage('personalInfoPage'));
    }
    else{
        if(result.Body?.successCatalogResult.codeError == "0730123"){
          thunkAPI.dispatch(setErrorPage({ errorType: 'ALREADY_EXIST'}));
        }
        else{
          thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR'}));
        }
    }


    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR' , isOpenWorkOrder: false, description:'get energy sale oder price error' }));
  } finally {
  }
});

export const getEMVStep1 = createAsyncThunk('energySaleBlock/getEMVStep1', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().energySaleBlock;
    let totalPrice = state.totalPrice && state.totalPrice != '' ? state.totalPrice : '0';
    const type = cgTypeEnum.CHECKCARD;
    let customerId = '0';

    if (Config.cgShowIdNumber == 'True' && state.otpDetails.identityNumber) {
      customerId = state.otpDetails.identityNumber;
    }

    const result = await ProviderManager.getProviderData('getCGEMVStep1', [type, customerId, totalPrice, '1', 'energySaleJet', false,'PaymentenErgySaleJet']);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getEMVStep2 = createAsyncThunk('energySaleBlock/getEMVStep2', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().energySaleBlock;
    const totalPrice = '100'; //DEFAULT VALUE
    const blockId = state.energySaleBlockData.blockId;
    const isShowIdNumber = Config.cgShowIdNumber;
    const type = cgTypeEnum.CHECKCARD;
    let customerId = data.id;
    const result = await ProviderManager.getProviderData('getCGEMVStep2', [
      totalPrice,
      data.token,
      type,
      isShowIdNumber,
      customerId,
      blockId,
      'energySaleJet',
      false,
      'EnergySaleBlock'
    ]);
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR' , isOpenWorkOrder: true, description:'שגיאה בפרטי אמצעי תשלום מול קרדיט גארד' }));
    return error;
  }
});

export const createWorkOrder = createAsyncThunk('energySaleBlock/createWorkOrder', async (data, thunkAPI) => {
  try {
    const energySaleBlock = thunkAPI.getState().energySaleBlock;
    var response = await callOpenWorkOrderForEnergySaleJet(energySaleBlock);
    return response;
  } catch (error) {
  } finally {
  }
});

export const openWhatsAppLink = createAsyncThunk('energySaleBlock/openWhatsAppLink', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().energySaleBlock;

    const isWhatsAppActive = state.energySaleBlockData.isWhatsAppActive;
    const whatsAppPhoneNumber = state.energySaleBlockData.whatsAppServiceNumber;

    if(isWhatsAppActive){
      var whatsappUrl = "https://api.whatsapp.com/send?phone=" + whatsAppPhoneNumber
      window.open(whatsappUrl, '_blank');
    }

    return true;
  } catch (error) {
    return false;
  } finally {
  }
});

export const createSale = createAsyncThunk('energySaleBlock/createSale', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().energySaleBlock;

    const request =     {
      saleType: state.saleType,
      offerId: state.selectedPackage.offerId,
      offerName: state.selectedPackage?.title,
      selectedAddress: {
        city: state.userAddress.citySemel,
        cityName: state.userAddress.cityName,
        street: state.userAddress.streetSemel,
        streetName: state.userAddress.streetName,
        streetGisSemel: state.userAddress.streetGisSemel,
        houseNumber: state.userAddress.home,
        aptNumber: state.userAddress.apartment,
        entrance: '',
        floor: 0,
        postalCode: state.userAddress.zipCode
      },
      personalInfo: {
        idNumber: state.otpDetails.identityNumber,
        paymentCardDueYear: state.paymentInfo.CardDueYear,
        paymentCardDueMonth: state.paymentInfo.CardDueMonth,
        paymentCcType: state.paymentInfo.CCType,
        paymentCcToken: state.paymentInfo.CCToken,
        paymentAuthNumber: state.paymentInfo.confirmationNumber,
        paymentTerminalNumber: 'CheckCard',
        eMail: state.personalInfo.email,
        lastName: state.personalInfo.lastName,
        firstName: state.personalInfo.firstName,
        isReceivingAd: state.personalInfo.isReceivingAd,
        isReceivingBill: true,
        otpPhone: state.otpDetails.phoneNumber
      },
      energyInfo: {
        energyFileId: state.signatureInfo.fileGuid,
        isSignPowerOfAttorney: state.signatureInfo.isSigned,
        isSmart: state.iecResponse.serviceMigratable,
        contractId: state.iecResponse.contractId,
        currentConsumption: state.iecResponse.currentConsumption
      },
      orders: [
        {
          orderId: state.summaryDetails.orderId,
          orderType: state.orderType
        }
      ]
    }

    const result = await ProviderManager.getProviderData('energySaleCreateSale', request);
    thunkAPI.dispatch(hideAppLoader());

    if(result.Body?.isSuccess){
        thunkAPI.dispatch(goToPage('successPage'));
    }
    else{
      thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR'}));
    }


    return result?.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR' , isOpenWorkOrder: false, description:'שגיאה כללית ביצירת הזמנה' }));
  } finally {
  }
});

export const createEnergySignatureFile = createAsyncThunk('energySaleBlock/createEnergySignatureFile', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().energySaleBlock;

    const formType = state.iecResponse.serviceMigratable ? state.energySaleBlockData.formCodeSmartMeter : state.energySaleBlockData.formCodeNotSmartMeter;

    const request =  {
      idNumber: state.otpDetails.identityNumber,
      subscriberNumber: state.otpDetails.phoneNumber,
      lastName: state.personalInfo.lastName,
      firstName: state.personalInfo.firstName,
      destMail: state.personalInfo.email,
      engi: state.iecResponse.currentConsumption,
      contractId: state.iecResponse.contractId,
      city: state.userAddress.cityName,
      street: state.userAddress.streetName,
      houseNum: state.userAddress.home,
      apartment: state.userAddress.apartment,
      zipCode: state.userAddress.zipCode,
      dealType: formType
    };

    const result = await ProviderManager.getProviderData('createEnergySignatureFile', request);
    thunkAPI.dispatch(hideAppLoader());

    // if(result.Body.isSuccess){
    //   window.open(result.Body.signUrl, '_blank');
    // }

    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR' , isOpenWorkOrder: true, description:'create energy signature file error' }));
  } finally {
  }
});

export const getEnergySignatureFileStatus = createAsyncThunk('energySaleBlock/getEnergySignatureFileStatus', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const state = thunkAPI.getState().energySaleBlock;

    const request =  {
      fileGuid: state.signatureInfo.fileGuid
    };

    const result = await ProviderManager.getProviderData('getEnergySignatureFileStatus', request);
    thunkAPI.dispatch(hideAppLoader());

    if(result.Body.isSuccess){
      if(result.Body.isSigned){
        gtag4({
          event: 'Energy_Step7_PoaUpdatePaymentMethod',
          step: '7',
          action: 'PoaUpdatePaymentMethod',
          funnel_name: state.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
        });
        thunkAPI.dispatch(goToPage('paymentPage'));
      }
      else{
        thunkAPI.dispatch(setErrorText('כדי להמשיך יש לחתום על טופס ייפוי כוח'));
      }
    }

    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(setErrorPage({ errorType: 'GENERAL_ERROR' , isOpenWorkOrder: true, description:'קבלת סטאטוס האם חתם בטופס יפוי כוח' }));
  } finally {
  }
});

function setPageResponse(data , thunkAPI){
  const state = thunkAPI.getState().energySaleBlock;
  if(data.state.toLowerCase() == 'completed'){
    if(data.multipleCounters){
        thunkAPI.dispatch(setErrorPage({errorType: 'HAS_MULTIPLE_COUNTERS' , isOpenWorkOrder: true, description: 'אין לאפשר מכר חשמל באתר כאשר לת"ז יש יותר ממונה אחד בחח"י' }));
    }
    else if(data.serviceMigratable){ //SMART METER
      if(state.isStartWithSelectedPackage){
        if(!state.selectedPackage.isSmartMeterPackage && !state.selectedPackage.isSuitableForAllMeterTypesPackage){
          thunkAPI.dispatch(setDisplayAlternativePackage(true));
          thunkAPI.dispatch(goToPage('packagesPage'));
        }
        else if(state.selectedPackage.isSmartMeterPackage || state.selectedPackage.isSuitableForAllMeterTypesPackage){
          thunkAPI.dispatch(getOderPrice());
        }
      }
      else{
        thunkAPI.dispatch(goToPage('packagesPage'));
      }
    }
    else{ //NOT SMART METER
      if(!data.currentConsumption){
        thunkAPI.dispatch(setErrorPage({errorType: 'EMPTY_DETAILS' , isOpenWorkOrder: true, description: 'אין מונה חכם ומספר מונה' }));
      }
      else{
        if(state.isStartWithSelectedPackage){
          if(state.selectedPackage.isSmartMeterPackage && !state.selectedPackage.isSuitableForAllMeterTypesPackage){
            thunkAPI.dispatch(setDisplayAlternativePackage(true));
            thunkAPI.dispatch(goToPage('packagesPage'));
          }
          else if(state.selectedPackage.isSuitableForAllMeterTypesPackage){
            thunkAPI.dispatch(getOderPrice());
          }
        }
        else{
          thunkAPI.dispatch(goToPage('packagesPage'));
        }
      }
    }
  }
  else if(data.state.toLowerCase() == 'error'){
    if(data.multipleCounters){
        thunkAPI.dispatch(setErrorPage({errorType: 'HAS_MULTIPLE_COUNTERS' , isOpenWorkOrder: true, description: 'אין לאפשר מכר חשמל באתר כאשר לת"ז יש יותר ממונה אחד בחח"י' }));
    }else{
        thunkAPI.dispatch(setErrorPage({errorType: 'GENERAL_ERROR' , isOpenWorkOrder: true, description: 'שגיאה בקבלת פרטים על הלקוח מחברת החשמל' }));
    }
  }
  else if(data.state.toLowerCase() == 'notfound'){
    thunkAPI.dispatch(setErrorPage({errorType: 'EMPTY_DETAILS' , isOpenWorkOrder: true, description: 'לקוח לא נמצא' }));
  }
  else{
    thunkAPI.dispatch(setServiceMessageType('WITHOUT_DETAILS'));
    thunkAPI.dispatch(goToPage('serviceMessagePage'));
  }
}

function getErrorDescription(interfaceNumber , errorMassage){
  let errorDescription = errorMassage;
  switch (interfaceNumber) {
    case '1650':
      errorDescription = errorDescription + ' - ' + 'בדיקה אם יש הזמנה על המספר מונה - ממשק 1650';
      break;
    case '0881':
    case '881':
      errorDescription = errorDescription + ' - ' + ' ת.ז ברשימה שחורה - ממשק 0881';
      break;
    case '1852':
      errorDescription = errorDescription + ' - ' + ' שגיאה ביצירת הזמנה - ממשק 1852';
      break;
    case '1853':
      errorDescription = errorDescription + ' - ' + ' שגיאה בהזמנה - ממשק 1853';
      break;
    case '1434':
      errorDescription = errorDescription + ' - ' + 'שגיאה בבדיקת פרטי אשראי - ממשק 1434';
      break;
    case '0667':
    case '667':
      errorDescription = errorDescription + ' - ' + 'שגיאה בבקרת אשראי - ממשק 0667';
      break;
    case '1426':
      errorDescription = errorDescription + ' - ' + 'שגיאה בשליפת מחזור לחיוב - ממשק 1426';
      break;
    case '1443':
      errorDescription = errorDescription + ' - ' + 'שגיאה בהקמת לקוח - ממשק 1443';
      break;
    case '1855':
      errorDescription = errorDescription + ' - ' + 'שגיאה בשליפת פרטי קונסיומר ואיש קשר ראשי - ממשק 1855 ';
      break;
    case '1784':
      errorDescription = errorDescription + ' - ' + 'שגיאה ביצירת הזמנה - ממשק 1784';
      break;
    case '1989':
      errorDescription = errorDescription + ' - ' + 'שגיאה בצד ג :מייל + מנוי - ממשק 1989 ';
      break;
  }
}
